import { useCallback } from "react";
import { authAxios } from "./axios";

export const useLogout = () => {
  const [state, execute, cancel] = authAxios<void, void, unknown>({
    url: "/logout",
    method: "POST",
  });

  const callback = useCallback(async () => {
    const result = await execute();
    localStorage.setItem("isLogged", "");
    sessionStorage.clear();
    return result;
  }, [execute]);

  return [state, callback, cancel] as const;
};
